<div class="custom-header">
  <ess-button class="icon" [buttonType]="'button'" (click)="previousClicked()">
    <i [innerHTML]="chevronLeft"></i>
  </ess-button>
  <p class="custom-header-label sans">{{ periodLabel }}</p>
  <ess-button class="icon" [buttonType]="'button'" (click)="nextClicked()" data-cy="dates-right-btn">
    <i [innerHTML]="chevronRight"></i>
  </ess-button>
</div>
